import { HomeIcon, PlusCircle, UserIcon } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import { useCampaign } from "@/contexts/CampaignContext";

const navigation = [
	{ name: "Dashboard", href: "/", icon: HomeIcon },
	{
		name: "Create Campaign",
		href: "/create",
		icon: PlusCircle,
		subItems: [
			{ name: "Campaign Details", href: "/create" },
			{ name: "Audience Targeting", href: "/create/audience" },
			{ name: "Creative", href: "/create/creative" },
			{ name: "Contact Info", href: "/create/contact" },
			{ name: "Campaign Overview", href: "/create/overview" },
		],
	},
	{ name: "Profile", href: "/profile", icon: UserIcon },
];

export function Sidebar() {
	const location = useLocation();
	const navigate = useNavigate();
	const { resetCampaign } = useCampaign();

	const handleNavigation = (href: string, isCreateCampaign: boolean) => {
		if (isCreateCampaign) {
			resetCampaign();
		}
		navigate(href);
	};

	return (
		<div className="flex h-full w-64 flex-col bg-white/80 backdrop-blur-sm border-r">
			<div className="flex-1 space-y-1 p-4">
				{navigation.map((item) => {
					const isActive =
						location.pathname === item.href ||
						(item.subItems &&
							item.subItems.some((sub) => location.pathname === sub.href));
					const showSubItems =
						item.subItems && location.pathname.startsWith("/create");
					const isCreateCampaign = item.href === "/create";

					return (
						<div key={item.name}>
							<button
								onClick={() => handleNavigation(item.href, isCreateCampaign)}
								className={`flex w-full items-center px-4 py-3 text-sm font-medium rounded-lg transition-colors ${
									isActive
										? "bg-primary text-primary-foreground"
										: "text-muted-foreground hover:bg-secondary"
								}`}>
								<item.icon className="mr-3 h-5 w-5" />
								{item.name}
							</button>

							{showSubItems && item.subItems && (
								<div className="ml-6 mt-2 space-y-1">
									{item.subItems.map((subItem) => (
										<button
											key={subItem.name}
											onClick={() => handleNavigation(subItem.href, false)}
											className={`flex w-full items-center px-4 py-2 text-sm font-medium rounded-lg transition-colors ${
												location.pathname === subItem.href
													? "bg-primary text-primary-foreground"
													: "text-muted-foreground hover:bg-secondary/50"
											}`}>
											{subItem.name}
										</button>
									))}
								</div>
							)}
						</div>
					);
				})}
			</div>
		</div>
	);
}
